__turbopack_context__.v({
  "container": "switch-module-scss-module__mdHPkq__container",
  "disabled": "switch-module-scss-module__mdHPkq__disabled",
  "error": "switch-module-scss-module__mdHPkq__error",
  "helper-text": "switch-module-scss-module__mdHPkq__helper-text",
  "input": "switch-module-scss-module__mdHPkq__input",
  "input-wrapper": "switch-module-scss-module__mdHPkq__input-wrapper",
  "knob": "switch-module-scss-module__mdHPkq__knob",
  "label": "switch-module-scss-module__mdHPkq__label",
  "primary": "switch-module-scss-module__mdHPkq__primary",
  "secondary": "switch-module-scss-module__mdHPkq__secondary",
  "slider": "switch-module-scss-module__mdHPkq__slider",
});
